/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './AdditionalNotifications.scss';

import { bool, func } from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import {
  EDUCATION_INSIGHTS_CATEGORY_ID,
  OPT_OUT_CATEGORY_ID,
  PRODUCTS_SERVICES_CATEGORY_ID,
  RESEARCH_SURVEYS_CATEGORY_ID
} from 'services/Preferences';
import { ReactComponent as EmailIcon } from 'assets/icons/email.svg';
import LabeledIcon from 'components/shared/LabeledIcon/LabeledIcon';
import MobileSubscriptionsHeaderRow from 'components/layouts/Preferences/Subscriptions/shared/MobileSubscriptionsHeaderRow';
import SubscriptionsCheckbox from 'components/layouts/Preferences/Subscriptions/shared/SubscriptionsCheckbox';
import SubscriptionsHeaderRow from 'components/layouts/Preferences/Subscriptions/shared/SubscriptionsHeaderRow';
import SubscriptionsRow from 'components/layouts/Preferences/Subscriptions/shared/SubscriptionsRow';
import SubscriptionsRowLabel from 'components/layouts/Preferences/Subscriptions/shared/SubscriptionsRowLabel';
import Content from 'services/Content';
import { isDesktopLayout } from 'state/view/ViewSelectors';
import { getHasInvalidOrNoEmailAddress } from 'state/contactMethodMaintenance/ContactMethodMaintenanceSelectors';

const AdditionalNotifications = ({
                                   isDesktopLayout,
                                   optStatus,
                                   hasInvalidOrMissingEmail,
                                   subscriptions
                                 }) => {
  const onOptChange = (key) => (checked) => {
    if (key === 'optOut') {
      optStatus(checked);
    } else {
      optStatus(key, checked);
    }
  };

  const { optOutElections } = subscriptions;

  const optOutAll =
    optOutElections.some(
      (election) =>
        election.categoryId === OPT_OUT_CATEGORY_ID && !election.optOut
    ) ||
    (optOutElections.some(
        (election) =>
          election.categoryId === PRODUCTS_SERVICES_CATEGORY_ID && election.optOut
      ) &&
      optOutElections.some(
        (election) =>
          election.categoryId === RESEARCH_SURVEYS_CATEGORY_ID &&
          election.optOut
      ) &&
      optOutElections.some(
        (election) =>
          election.categoryId === EDUCATION_INSIGHTS_CATEGORY_ID &&
          election.optOut
      ));

  const educationInsights = optOutElections.find((election) => {
    const { categoryId } = election;
    if (categoryId === EDUCATION_INSIGHTS_CATEGORY_ID) {
      return election;
    }
  });

  const productsServices = optOutElections.find((election) => {
    const { categoryId } = election;
    if (categoryId === PRODUCTS_SERVICES_CATEGORY_ID) {
      return election;
    }
  });

  const researchSurveys = optOutElections.find((election) => {
    const { categoryId } = election;
    if (categoryId === RESEARCH_SURVEYS_CATEGORY_ID) {
      return election;
    }
  });

  return (
    <div className="additional-notifications">
      {isDesktopLayout ? (
        <SubscriptionsHeaderRow header="Additional Notifications">
          <LabeledIcon icon={EmailIcon} label="Subscribed" />
        </SubscriptionsHeaderRow>
      ) : (
        <MobileSubscriptionsHeaderRow header="Additional Notifications">
          <div>Communication Type</div>
          <div>Subscribed</div>
        </MobileSubscriptionsHeaderRow>
      )}
      <div className="subscription-rows">
        <SubscriptionsRow>
          <SubscriptionsRowLabel
            label="Education &amp; Insights"
            modalContent={Content.subscriptionsEducationInsights}
          />
          <SubscriptionsCheckbox
            checked={
              (!hasInvalidOrMissingEmail &&
                !optOutAll &&
                educationInsights &&
                !educationInsights.optOut) ||
              !educationInsights
            }
            name="education-and-insights"
            disabled={hasInvalidOrMissingEmail}
            onChange={onOptChange('educationInsights')}
          />
        </SubscriptionsRow>

        <SubscriptionsRow>
          <SubscriptionsRowLabel
            label="Products &amp; Services"
            modalContent={Content.subscriptionsProductsServices}
          />
          <SubscriptionsCheckbox
            checked={
              (!hasInvalidOrMissingEmail &&
                !optOutAll &&
                productsServices &&
                !productsServices.optOut) ||
              !productsServices
            }
            name="products-and-services"
            onChange={onOptChange('productsServices')}
            disabled={hasInvalidOrMissingEmail}
          />
        </SubscriptionsRow>

        <SubscriptionsRow>
          <SubscriptionsRowLabel
            label="Research &amp; Surveys"
            modalContent={Content.subscriptionsResearchSurveys}
          />
          <SubscriptionsCheckbox
            checked={
              (!hasInvalidOrMissingEmail &&
                !optOutAll &&
                researchSurveys &&
                !researchSurveys.optOut) ||
              !researchSurveys
            }
            name="research-and-surveys"
            onChange={onOptChange('researchSurveys')}
            disabled={hasInvalidOrMissingEmail}
          />
        </SubscriptionsRow>

        <SubscriptionsRow>
          <SubscriptionsRowLabel label="Opt out of additional notifications" />
          <SubscriptionsCheckbox
            checked={!hasInvalidOrMissingEmail && optOutAll}
            name="opt-out-of-additional-notifications"
            onChange={onOptChange('optOutAll')}
            disabled={hasInvalidOrMissingEmail}
          />
        </SubscriptionsRow>
      </div>
      <div className="additional-notifications-footer">
        {Content.subscriptionsAdditionalNotificationsFooter}
      </div>
    </div>
  );
};

AdditionalNotifications.propTypes = {
  isDesktopLayout: bool.isRequired,
  optStatus: func.isRequired,
  hasInvalidOrMissingEmail: bool.isRequired
};

const mapStateToProps = (state) => ({
  isDesktopLayout: isDesktopLayout(state),
  hasInvalidOrMissingEmail: getHasInvalidOrNoEmailAddress(state)
});

export default connect(mapStateToProps)(AdditionalNotifications);
